@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) './splittable-row/items-table-row.module.less';

.header-row {
  height: 40px;
  background-color: @split-ship-table--header--background-color;
  font-size: 12px;
}

.header-cell {
  font-weight: 500;
  padding-left: 16px;
}

.sortable-column {
  cursor: pointer;
}

.name-column-header {
  .header-cell();
  .name-column();
  .sortable-column();
}

.quantity-column-header {
  .header-cell();
  .quantity-column();
  .sortable-column();
}

.shipment-column-header {
  .header-cell();
  .shipment-column();
  .sortable-column();
}

.status-column-header {
  .header-cell();
  .status-column();
  .sortable-column();
}

.actions-column-header {
  .header-cell();
  .actions-column();
}

.sort-icon {
  margin-left: 8px;
  height: 15px;
  width: 15px;
  color: @split-ship-table--sort-icon--unsorted--fill-color;
}

.sorted-sort-icon {
  .sort-icon();
  color: @split-ship-table--sort-icon--sorted--fill-color;
}

.header-cell-content {
  height: 100%;
  display: flex;
  align-items: center;
}
